<div>
	{{ "forgotpassword.description" | translate }}.
</div>
<form [formGroup]="form" (ngSubmit)="forgotPassword()" novalidate>
	<div class="sdp-form-control">
		<mat-form-field class="sdp-form-control-input-container">
			<input matInput placeholder="{{ 'form.label.email' | translate }}" type="text" formControlName="email">
		</mat-form-field>
	</div>
	<div class="sdp-form-buttons-container">
		<button class="sdp-button-small-text" type="button" color="primary" mat-button (click)="back()">{{ "form.label.back" | translate }}</button>
		<button color="primary" type="submit" mat-raised-button>{{ "form.label.continue" | translate }}</button>
	</div>
</form>